const generateCron = (schedule) => {
  const { frequency, repeat, perform, occurs, startDate } = schedule;

  const hour = startDate.getHours();
  const minute = startDate.getMinutes();

  const time = `0 ${minute} ${hour}`;

  switch (frequency.toLowerCase()) {
    case "daily":
      switch (repeat[0] || 0) {
        case 0: // everyday
          return `${time} * * ?`;
        case 1: // alternate days
          return `${time} 1/2 * ?`;
        case 2: // weekdays
          return `${time} ? * 1-5`;
        default:
          console.error("Invalid repeat option for daily frequency");
          return "";
      }

    case "weekly":
      return `${time} ? * ${repeat.map((dayOfWeek) => dayOfWeek + 1).join()}`;

    case "monthly":
      if (perform.toLowerCase() === "day") {
        return `${time} ${occurs[0] + 1} ${
          repeat.length ? repeat.join() : "*"
        } ?`;
      } else if (perform.toLowerCase() === "week") {
        return `${time} ? ${repeat.length ? repeat.join() : "*"} ${occurs[1]}#${
          occurs[0] + 1
        }`;
      }
      throw new Error("Invalid perform option for monthly frequency");

    default:
      throw new Error("Invalid frequency option");
  }
};

export default generateCron;
